import { render, staticRenderFns } from "./shared-briefcase.html?vue&type=template&id=d5f9b8d8&scoped=true&external"
import script from "./shared-briefcase.js?vue&type=script&lang=js&external"
export * from "./shared-briefcase.js?vue&type=script&lang=js&external"
import style0 from "./shared-briefcase.scss?vue&type=style&index=0&id=d5f9b8d8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f9b8d8",
  null
  
)

export default component.exports